module.exports = "../static/media/banner_short.b7739438.png";